import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Decimal: { input: string; output: string; }
};

export type AcademyCourse = {
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  exam: Maybe<CourseExam>;
  externalId: Maybe<Scalars['String']['output']>;
  externalUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userProgress: Maybe<CourseUserProgress>;
};

export type AccessManagementResult = {
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** User account. */
export type Account = {
  birthDate: Maybe<Scalars['DateTime']['output']>;
  /** Whether user has linked the Telegram bot (can receive notifications). */
  botLinked: Scalars['Boolean']['output'];
  /** Whether user can access admin panel. */
  canAccessAdmin: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** User's email (if registered via email). */
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Gender>;
  /** Whether user has set a password (for email login). */
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  /** User's ministry memberships. */
  ministries: Array<AccountMinistryMembership>;
  /** User's permission codes for client-side checks. */
  permissions: Array<Scalars['String']['output']>;
  /** User's roles (e.g., member, minister, leader, admin). */
  roles: Array<Role>;
  telegramId: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

/**
 * Account merge request.
 * Represents a pending request to merge two accounts.
 */
export type AccountMergeRequest = {
  createdAt: Scalars['DateTime']['output'];
  /** Whether current user has confirmed from their side. */
  currentUserConfirmed: Scalars['Boolean']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether the other user has confirmed from their side. */
  otherUserConfirmed: Scalars['Boolean']['output'];
  /** Account that will be deleted after merge (data transferred to target). */
  sourceAccount: ConflictingAccountInfo;
  status: AccountMergeStatus;
  /** Account that will remain after merge (older account). */
  targetAccount: ConflictingAccountInfo;
};

/** Status of account merge request. */
export enum AccountMergeStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** User's membership in a ministry. */
export type AccountMinistryMembership = {
  joinedAt: Scalars['DateTime']['output'];
  ministry: Ministry;
  role: MinistryRole;
};

export type AccountOrderStatusCount = {
  count: Scalars['Int']['output'];
  status: OrderStatus;
};

export type ActiveGenderParty = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: GenderPartyStatus;
};

export type ActiveRaffle = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: RaffleStatus;
};

/** Response from addEmailToAccount mutation. */
export type AddEmailResult = {
  /** If MERGE_REQUIRED, the created merge request. */
  mergeRequest: Maybe<AccountMergeRequest>;
  result: AddEmailResultType;
};

/** Result of adding email to account. */
export enum AddEmailResultType {
  /** Account already has this email linked. */
  AlreadyLinked = 'ALREADY_LINKED',
  /** Email belongs to another account. Merge request created. */
  MergeRequired = 'MERGE_REQUIRED',
  /** Verification code sent to email. Proceed to verifyEmailLink. */
  Sent = 'SENT'
}

/** Input for adding a member to a ministry. */
export type AddMinistryMemberInput = {
  accountId: Scalars['ID']['input'];
  role: MinistryRole;
};

export type AdminAccount = {
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
  telegramId: Scalars['String']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type AdminDashboardStats = {
  ordersToday: Scalars['Int']['output'];
  pendingVerification: Scalars['Int']['output'];
  ticketsIssuedToday: Scalars['Int']['output'];
};

export type AdminEventWithStats = {
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  ordersCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  startsAt: Scalars['DateTime']['output'];
  ticketsCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  venue: Maybe<Scalars['String']['output']>;
};

export type AdminFeedbackMessagesFilter = {
  status?: InputMaybe<FeedbackStatus>;
};

export type AdminHomeGroupsFilter = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filter for admin ministries list. */
export type AdminMinistriesFilter = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminOrder = {
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  event: Event;
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  receiptUploadedAt: Maybe<Scalars['DateTime']['output']>;
  receiptUrl: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  tickets: Array<AdminTicket>;
  totalAmount: Scalars['Decimal']['output'];
};

export type AdminOrdersFilter = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
};

export type AdminOrdersResult = {
  orders: Array<AdminOrder>;
  statusCounts: Array<AccountOrderStatusCount>;
  totalCount: Scalars['Int']['output'];
};

export type AdminOrdersStats = {
  pendingVerification: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
  totalTickets: Scalars['Int']['output'];
};

export type AdminOverviewStats = {
  activeMinistryMembersThisWeek: Scalars['Int']['output'];
  eventsThisWeek: Scalars['Int']['output'];
  homeGroupAttendanceThisWeek: Scalars['Int']['output'];
  newAccountsThisWeek: Scalars['Int']['output'];
  pendingPayments: Scalars['Int']['output'];
  totalAccounts: Scalars['Int']['output'];
};

/** Filter for admin stories list. */
export type AdminStoriesFilter = {
  hasExpired?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminTicket = {
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  issuedAt: Scalars['DateTime']['output'];
  status: TicketStatus;
  ticketNumber: Scalars['String']['output'];
  ticketType: TicketType;
  usedAt: Maybe<Scalars['DateTime']['output']>;
};

export type AdminTicketFull = {
  account: Customer;
  event: Event;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  issuedAt: Scalars['DateTime']['output'];
  order: AdminTicketOrder;
  status: TicketStatus;
  ticketNumber: Scalars['String']['output'];
  ticketType: TicketType;
  usedAt: Maybe<Scalars['DateTime']['output']>;
};

export type AdminTicketOrder = {
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

export type AdminTicketsFilter = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TicketStatus>;
};

export type AdminTicketsResult = {
  tickets: Array<AdminTicketFull>;
  totalCount: Scalars['Int']['output'];
};

export type AnswerExamQuestionResult = {
  attempt: Maybe<ExamAttempt>;
  completed: Scalars['Boolean']['output'];
  correct: Scalars['Boolean']['output'];
  courseUrl: Maybe<Scalars['String']['output']>;
  nextQuestion: Maybe<ExamQuestionView>;
  wrongAttemptCount: Scalars['Int']['output'];
};

/** Authentication result with account and tokens. */
export type AuthResult = {
  account: Account;
  tokens: AuthTokens;
};

/** Authentication tokens for persistent session. */
export type AuthTokens = {
  /**
   * Short-lived access token (1 hour).
   * Use in Authorization header: Bearer <accessToken>
   */
  accessToken: Scalars['String']['output'];
  /** When the access token expires. */
  expiresAt: Scalars['DateTime']['output'];
  /**
   * Long-lived refresh token (30 days).
   * Use to obtain new access token when it expires.
   */
  refreshToken: Scalars['String']['output'];
};

export type CashTicketItemInput = {
  quantity: Scalars['Int']['input'];
  ticketTypeId: Scalars['ID']['input'];
};

/**
 * Category for filtering and grouping events.
 * Supports hierarchical structure (parent/children).
 */
export type Category = {
  /** Child categories. */
  children: Array<Category>;
  code: Scalars['String']['output'];
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Number of events in this category. */
  eventCount: Scalars['Int']['output'];
  icon: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Parent category (for hierarchical structure). */
  parent: Maybe<Category>;
  sortOrder: Scalars['Int']['output'];
};

/** Input for creating/updating a category. */
export type CategoryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ChurchInfo = {
  address: Maybe<Scalars['String']['output']>;
  companyDetails: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  mapUrl: Maybe<Scalars['String']['output']>;
  parkingText: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  scheduleText: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usefulChats: Array<UsefulChat>;
  welcomeAboutText: Maybe<Scalars['String']['output']>;
  welcomeAboutTitle: Maybe<Scalars['String']['output']>;
  welcomeDaysCount: Maybe<Scalars['Int']['output']>;
  welcomeHeroImageUrl: Maybe<Scalars['String']['output']>;
  welcomeHeroSubtitle: Maybe<Scalars['String']['output']>;
  welcomeHeroTitle: Maybe<Scalars['String']['output']>;
  welcomeHeroVideoUrl: Maybe<Scalars['String']['output']>;
  welcomeMissionText: Maybe<Scalars['String']['output']>;
  welcomeText: Maybe<Scalars['String']['output']>;
};

export type ChurchInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyDetails?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mapUrl?: InputMaybe<Scalars['String']['input']>;
  parkingText?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  scheduleText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  usefulChats?: InputMaybe<Array<UsefulChatInput>>;
  welcomeAboutText?: InputMaybe<Scalars['String']['input']>;
  welcomeAboutTitle?: InputMaybe<Scalars['String']['input']>;
  welcomeDaysCount?: InputMaybe<Scalars['Int']['input']>;
  welcomeHeroImageUrl?: InputMaybe<Scalars['String']['input']>;
  welcomeHeroSubtitle?: InputMaybe<Scalars['String']['input']>;
  welcomeHeroTitle?: InputMaybe<Scalars['String']['input']>;
  welcomeHeroVideoUrl?: InputMaybe<Scalars['String']['input']>;
  welcomeMissionText?: InputMaybe<Scalars['String']['input']>;
  welcomeText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Information about a conflicting account (for merge confirmation UI).
 * Shows limited info for security.
 */
export type ConflictingAccountInfo = {
  /** When account was created. */
  createdAt: Scalars['DateTime']['output'];
  /** First name (if set). */
  firstName: Maybe<Scalars['String']['output']>;
  /** Whether account has email. */
  hasEmail: Scalars['Boolean']['output'];
  /** Whether account has Telegram. */
  hasTelegram: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Number of orders on this account. */
  ordersCount: Scalars['Int']['output'];
  /** Number of tickets on this account. */
  ticketsCount: Scalars['Int']['output'];
};

export type CourseAnalytics = {
  averageWrongAttempts: Scalars['Float']['output'];
  course: AcademyCourse;
  examPassedCount: Scalars['Int']['output'];
  examStartedCount: Scalars['Int']['output'];
  inProgress: Array<ExamInProgressInfo>;
  passRate: Scalars['Float']['output'];
  passed: Array<ExamPassedInfo>;
  totalVisitors: Scalars['Int']['output'];
  visitors: Array<CourseVisitorInfo>;
};

export type CourseExam = {
  createdAt: Scalars['DateTime']['output'];
  currentAttempt: Maybe<ExamAttempt>;
  currentQuestion: Maybe<ExamQuestionView>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  passingScore: Scalars['Int']['output'];
  questionsCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseUserProgress = {
  examPassed: Scalars['Boolean']['output'];
  examPassedAt: Maybe<Scalars['DateTime']['output']>;
  examStarted: Scalars['Boolean']['output'];
  visitCount: Scalars['Int']['output'];
  visited: Scalars['Boolean']['output'];
};

export type CourseVisitorInfo = {
  account: Account;
  examPassed: Scalars['Boolean']['output'];
  examStarted: Scalars['Boolean']['output'];
  firstVisit: Scalars['DateTime']['output'];
  lastVisit: Scalars['DateTime']['output'];
  visitCount: Scalars['Int']['output'];
};

export type CreateAcademyCourseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CreateCourseExamInput = {
  courseId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  passingScore?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateExamQuestionInput = {
  correctAnswer: Scalars['String']['input'];
  examId: Scalars['ID']['input'];
  explanation?: InputMaybe<Scalars['String']['input']>;
  options: Array<ExamOptionInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<QuestionType>;
};

export type CreateOrderInput = {
  eventId: Scalars['ID']['input'];
  items: Array<OrderItemInput>;
};

export type Customer = {
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

/** Day of week. */
export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Draw = {
  drawnAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  prize: Prize;
  prizeId: Scalars['ID']['output'];
  raffleId: Scalars['ID']['output'];
  winningTicket: RaffleTicketInfo;
};

/** Event type. */
export type Event = {
  activeGenderParty: Maybe<ActiveGenderParty>;
  activeRaffle: Maybe<ActiveRaffle>;
  address: Maybe<Scalars['String']['output']>;
  bannerImageUrl: Maybe<Scalars['String']['output']>;
  categories: Array<Category>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  endsAt: Maybe<Scalars['DateTime']['output']>;
  featured: Scalars['Boolean']['output'];
  genderRestriction: Gender;
  hasMyTickets: Scalars['Boolean']['output'];
  homeGroup: Maybe<HomeGroup>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  inviteText: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isException: Scalars['Boolean']['output'];
  mapsUrl: Maybe<Scalars['String']['output']>;
  maxAge: Maybe<Scalars['Int']['output']>;
  maxAttendees: Maybe<Scalars['Int']['output']>;
  minAge: Maybe<Scalars['Int']['output']>;
  myRsvp: Maybe<EventRsvp>;
  organizers: Array<EventOrganizer>;
  program: Maybe<Scalars['String']['output']>;
  publishAt: Maybe<Scalars['DateTime']['output']>;
  requiresRsvpConfirmation: Scalars['Boolean']['output'];
  rsvpCounts: RsvpCounts;
  seriesId: Maybe<Scalars['ID']['output']>;
  slogan: Maybe<Scalars['String']['output']>;
  startsAt: Scalars['DateTime']['output'];
  status: EventStatus;
  streamVkUrl: Maybe<Scalars['String']['output']>;
  streamYoutubeUrl: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  telegramChatUrl: Maybe<Scalars['String']['output']>;
  ticketTypes: Array<TicketType>;
  title: Scalars['String']['output'];
  venue: Maybe<Scalars['String']['output']>;
  videoUrl: Maybe<Scalars['String']['output']>;
  visibility: EventVisibility;
};

export type EventInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowedMinistryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  genderRestriction?: InputMaybe<Gender>;
  homeGroupId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inviteText?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mapsUrl?: InputMaybe<Scalars['String']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  requiresRsvpConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<EventStatus>;
  streamVkUrl?: InputMaybe<Scalars['String']['input']>;
  streamYoutubeUrl?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  telegramChatUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  venue?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<EventVisibility>;
};

/** Event organizer (ministry and/or person). */
export type EventOrganizer = {
  account: Maybe<Account>;
  canEdit: Scalars['Boolean']['output'];
  canManageRsvp: Scalars['Boolean']['output'];
  canManageTickets: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ministry: Maybe<Ministry>;
  receiveNotifications: Scalars['Boolean']['output'];
  role: OrganizerRole;
};

export type EventOrganizerInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  canManageRsvp?: InputMaybe<Scalars['Boolean']['input']>;
  canManageTickets?: InputMaybe<Scalars['Boolean']['input']>;
  ministryId?: InputMaybe<Scalars['ID']['input']>;
  receiveNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<OrganizerRole>;
};

/** User's RSVP to an event. */
export type EventRsvp = {
  account: Maybe<Account>;
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  guestCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  note: Maybe<Scalars['String']['output']>;
  notifyOnChanges: Scalars['Boolean']['output'];
  source: RsvpSource;
  status: RsvpStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event publication status. */
export enum EventStatus {
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

/** Event visibility level. */
export enum EventVisibility {
  Church = 'CHURCH',
  Ministers = 'MINISTERS',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export type ExamAttempt = {
  completedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  maxScore: Scalars['Int']['output'];
  passed: Scalars['Boolean']['output'];
  percentage: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalWrongAttempts: Scalars['Int']['output'];
};

export type ExamInProgressInfo = {
  account: Account;
  attempt: ExamAttempt;
  currentQuestion: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalQuestions: Scalars['Int']['output'];
  wrongAttempts: Scalars['Int']['output'];
};

export type ExamOptionAdmin = {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ExamOptionInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ExamOptionView = {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ExamPassedInfo = {
  account: Account;
  attempt: ExamAttempt;
  duration: Scalars['Int']['output'];
  passedAt: Scalars['DateTime']['output'];
  wrongAttempts: Scalars['Int']['output'];
};

export type ExamQuestionAdmin = {
  correctAnswer: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  explanation: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options: Array<ExamOptionAdmin>;
  points: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  type: QuestionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ExamQuestionView = {
  id: Scalars['ID']['output'];
  options: Array<ExamOptionView>;
  questionNumber: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type FeeBreakdown = {
  amount: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  type: FeeType;
};

export enum FeeCalculation {
  Fixed = 'FIXED',
  Percent = 'PERCENT'
}

export type FeeConfiguration = {
  amount: Scalars['Decimal']['output'];
  calculation: FeeCalculation;
  currency: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prices: Array<FeeConfigurationPrice>;
  sortOrder: Scalars['Int']['output'];
  type: FeeType;
};

export type FeeConfigurationPrice = {
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FeeConfigurationPriceInput = {
  amount: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
};

export enum FeeType {
  Other = 'OTHER',
  Processing = 'PROCESSING',
  Service = 'SERVICE',
  Tax = 'TAX'
}

/** Admin view: who receives notifications when new feedback is submitted. */
export type FeedbackConfigAdmin = {
  account: Maybe<AdminAccount>;
  accountId: Scalars['ID']['output'];
};

export type FeedbackMessage = {
  accountId: Maybe<Scalars['ID']['output']>;
  adminNotes: Maybe<Scalars['String']['output']>;
  authorName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: FeedbackStatus;
  telegramId: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum FeedbackStatus {
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Resolved = 'RESOLVED'
}

/** Gender restriction. */
export enum Gender {
  Any = 'ANY',
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GenderParty = {
  allowVoteChange: Scalars['Boolean']['output'];
  answer: Maybe<GenderVote>;
  couplePhotoUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  event: Maybe<Event>;
  eventId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isTest: Scalars['Boolean']['output'];
  myVote: Maybe<GenderVote>;
  name: Scalars['String']['output'];
  partnerOneName: Scalars['String']['output'];
  partnerTwoName: Scalars['String']['output'];
  photos: Array<GenderPartyPhoto>;
  revealedAt: Maybe<Scalars['DateTime']['output']>;
  showResultsMode: ShowResultsMode;
  status: GenderPartyStatus;
  updatedAt: Scalars['DateTime']['output'];
  voteCounts: Maybe<GenderPartyVoteCounts>;
};

export type GenderPartyEventSummary = {
  activeGenderPartiesCount: Scalars['Int']['output'];
  coverImage: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  genderPartiesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  startDate: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type GenderPartyInput = {
  allowVoteChange?: InputMaybe<Scalars['Boolean']['input']>;
  answer?: InputMaybe<GenderVote>;
  couplePhotoUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  partnerOneName: Scalars['String']['input'];
  partnerTwoName: Scalars['String']['input'];
  showResultsMode?: InputMaybe<ShowResultsMode>;
};

export type GenderPartyPhoto = {
  caption: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  genderPartyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type GenderPartyPhotoInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
};

export enum GenderPartyStatus {
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Revealed = 'REVEALED',
  VotingClosed = 'VOTING_CLOSED',
  VotingOpen = 'VOTING_OPEN'
}

export type GenderPartyUpdateInput = {
  allowVoteChange?: InputMaybe<Scalars['Boolean']['input']>;
  answer?: InputMaybe<GenderVote>;
  couplePhotoUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerOneName?: InputMaybe<Scalars['String']['input']>;
  partnerTwoName?: InputMaybe<Scalars['String']['input']>;
  showResultsMode?: InputMaybe<ShowResultsMode>;
};

export type GenderPartyVoteCounts = {
  boyPercentage: Scalars['Float']['output'];
  boyVotes: Scalars['Int']['output'];
  girlPercentage: Scalars['Float']['output'];
  girlVotes: Scalars['Int']['output'];
  totalVotes: Scalars['Int']['output'];
};

export type GenderPartyVoteRecord = {
  accountId: Scalars['ID']['output'];
  accountName: Scalars['String']['output'];
  accountUsername: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  genderPartyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vote: GenderVote;
};

export enum GenderVote {
  Boy = 'BOY',
  Girl = 'GIRL'
}

/** Home group (small group meeting). */
export type HomeGroup = {
  /** Full address (only visible to members). */
  address: Maybe<Scalars['String']['output']>;
  /** Co-leader (optional). */
  coLeader: Maybe<Account>;
  description: Maybe<Scalars['String']['output']>;
  /** Gender restriction. */
  genderRestriction: Gender;
  id: Scalars['ID']['output'];
  /** Group image URL. */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** Whether the group is active. */
  isActive: Scalars['Boolean']['output'];
  /** Whether current user has marked this as favorite (requires auth). */
  isFavorite: Scalars['Boolean']['output'];
  /** Whether current user is a member (requires auth). */
  isMember: Scalars['Boolean']['output'];
  /** Whether the group is accepting new members. */
  isOpen: Scalars['Boolean']['output'];
  /** Geographic coordinates. */
  latitude: Maybe<Scalars['Float']['output']>;
  /** Group leader. */
  leader: Account;
  /** Location/district name (only visible to members). */
  location: Maybe<Scalars['String']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  /** Google Maps link. */
  mapsUrl: Maybe<Scalars['String']['output']>;
  /** Maximum age requirement. */
  maxAge: Maybe<Scalars['Int']['output']>;
  /** Maximum capacity per meeting. */
  maxCapacity: Maybe<Scalars['Int']['output']>;
  /** Number of active members. */
  memberCount: Scalars['Int']['output'];
  /** Members list (only visible to group members and admins). */
  members: Array<HomeGroupMember>;
  /** Minimum age requirement. */
  minAge: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Regular meeting schedules. */
  schedules: Array<HomeGroupSchedule>;
};

/** Filter for home groups. */
export type HomeGroupFilter = {
  genderRestriction?: InputMaybe<Gender>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating/updating a home group. */
export type HomeGroupInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  coLeaderId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genderRestriction?: InputMaybe<Gender>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  leaderId?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapsUrl?: InputMaybe<Scalars['String']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Home group member. */
export type HomeGroupMember = {
  account: Account;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  role: HomeGroupRole;
};

/** Role within a home group. */
export enum HomeGroupRole {
  CoLeader = 'CO_LEADER',
  Leader = 'LEADER',
  Member = 'MEMBER'
}

/** Home group regular schedule. */
export type HomeGroupSchedule = {
  dayOfWeek: DayOfWeek;
  endTime: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  startTime: Scalars['String']['output'];
};

/** Input for home group schedule. */
export type HomeGroupScheduleInput = {
  dayOfWeek: DayOfWeek;
  endTime?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  startTime: Scalars['String']['input'];
};

export type HomeGroupsPageConfig = {
  bodyText: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type HomeGroupsPageConfigInput = {
  bodyText?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Response from linkTelegram mutation. */
export type LinkTelegramResponse = {
  /** If MERGE_REQUIRED, contains the conflicting account info for merge confirmation. */
  conflictingAccount: Maybe<ConflictingAccountInfo>;
  /** If MERGE_REQUIRED, contains the merge request ID. */
  mergeRequestId: Maybe<Scalars['ID']['output']>;
  result: LinkTelegramResult;
};

/** Result of attempting to link a Telegram account. */
export enum LinkTelegramResult {
  /** Current account already has this Telegram ID. */
  AlreadyLinked = 'ALREADY_LINKED',
  /** Telegram linked successfully to current account. */
  Linked = 'LINKED',
  /** Telegram ID belongs to another account - merge required. */
  MergeRequired = 'MERGE_REQUIRED'
}

export type ManualPayment = {
  id: Scalars['ID']['output'];
  receiptUploadedAt: Maybe<Scalars['DateTime']['output']>;
  receiptUrl: Maybe<Scalars['String']['output']>;
  rejectionReason: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  verifiedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum MessageAttachmentKind {
  Cover = 'COVER',
  Nothing = 'NOTHING',
  Tickets = 'TICKETS'
}

/** Church ministry/department (e.g., Worship, Youth, Kids, Media). */
export type Ministry = {
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  /** Number of active members. */
  memberCount: Scalars['Int']['output'];
  /** Members of this ministry (requires admin.access permission). */
  members: Array<MinistryMember>;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

/** Input for creating/updating a ministry. */
export type MinistryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Ministry member with their role. */
export type MinistryMember = {
  account: Account;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  role: MinistryRole;
};

/** Role within a ministry. */
export enum MinistryRole {
  Admin = 'ADMIN',
  Leader = 'LEADER',
  Member = 'MEMBER'
}

export type Mutation = {
  _empty: Maybe<Scalars['String']['output']>;
  /**
   * Add email to current account (for Telegram-only accounts).
   * Sends verification code to the email. After verification, email is linked.
   * Use verifyEmailLink to complete the process.
   *
   * Returns:
   * - SENT: Verification code sent, proceed to verifyEmailLink
   * - MERGE_REQUIRED: Email belongs to another account, merge request created
   * - ALREADY_LINKED: Account already has this email
   *
   * Requires authentication.
   */
  addEmailToAccount: AddEmailResult;
  addEventOrganizer: EventOrganizer;
  /** Add schedule to a home group (requires home_groups.manage or being the leader). */
  addHomeGroupSchedule: HomeGroupSchedule;
  /** Add a member to a ministry (requires ministries.manage permission). */
  addMinistryMember: MinistryMember;
  adminAddAllEventTickets: Scalars['Int']['output'];
  adminAddGenderPartyPhoto: GenderPartyPhoto;
  adminAddPrize: Prize;
  adminAssignRole: AccessManagementResult;
  /** Admin: clear feedback config (stop receiving feedback notifications in Telegram). */
  adminClearFeedbackConfig: Scalars['Boolean']['output'];
  /** Admin: clear pastor config (stop receiving pastor messages in Telegram). */
  adminClearPastorConfig: Scalars['Boolean']['output'];
  adminCloseGenderPartyVoting: GenderParty;
  adminCompleteRaffle: Raffle;
  adminCopyRaffle: Raffle;
  adminCreateGenderParty: GenderParty;
  adminCreateRaffle: Raffle;
  adminDeleteGenderParty: Scalars['Boolean']['output'];
  adminDeleteGenderPartyPhoto: Scalars['Boolean']['output'];
  adminDeletePrize: Scalars['Boolean']['output'];
  adminDeleteRaffle: Scalars['Boolean']['output'];
  adminDrawPrize: Draw;
  adminGrantPermission: AccessManagementResult;
  adminHideGenderPartyResults: GenderParty;
  adminNextPrize: Scalars['Boolean']['output'];
  adminOpenGenderPartyVoting: GenderParty;
  adminReadyRaffle: Raffle;
  adminReopenGenderPartyVoting: GenderParty;
  adminReorderGenderPartyPhotos: Array<GenderPartyPhoto>;
  adminReorderPrizes: Array<Prize>;
  adminResetTestGenderParty: GenderParty;
  adminResetTestRaffle: Raffle;
  adminRevealGenderPartyAnswer: GenderParty;
  adminRevealGenderPartyResults: GenderParty;
  adminRevokePermission: AccessManagementResult;
  adminRevokeRole: AccessManagementResult;
  adminSendOrderMessage: PaymentActionResult;
  /** Admin: set which account receives notifications for new feedback. */
  adminSetFeedbackConfig: FeedbackConfigAdmin;
  /** Admin: set which account receives pastor messages (by account ID). */
  adminSetPastorConfig: PastorConfigAdmin;
  adminSetRaffleTickets: Scalars['Boolean']['output'];
  adminShowCompleted: Scalars['Boolean']['output'];
  adminShowWinner: Scalars['Boolean']['output'];
  adminStartRaffle: Raffle;
  adminUnreadyGenderParty: GenderParty;
  adminUnreadyRaffle: Raffle;
  /** Admin: update feedback status and/or admin notes. */
  adminUpdateFeedback: FeedbackMessage;
  adminUpdateGenderParty: GenderParty;
  adminUpdatePrize: Prize;
  adminUpdateRaffle: Raffle;
  answerExamQuestion: AnswerExamQuestionResult;
  approvePayment: PaymentActionResult;
  /**
   * Authenticate via Telegram Mini App initData.
   * Validates initData and returns account + tokens so the mini-app can persist session (e.g. across lock/unlock).
   */
  authenticateWithInitData: AuthResult;
  /**
   * Authenticate via Telegram Login Widget.
   * Use this for PWA when user clicks "Login with Telegram" button.
   *
   * The widget data is validated using HMAC-SHA256.
   */
  authenticateWithWidget: AuthResult;
  /**
   * Cancel a pending merge request.
   * Can be cancelled by either party.
   * Requires authentication.
   */
  cancelMergeRequest: Scalars['Boolean']['output'];
  cancelOrder: Order;
  /**
   * Change password for the current account.
   * Requires current password for security.
   * Requires authentication.
   */
  changePassword: Scalars['Boolean']['output'];
  /**
   * Confirm a pending RSVP (organizer or admin only).
   * Changes status from PENDING to GOING.
   */
  confirmEventRsvp: EventRsvp;
  /**
   * Confirm a merge request from current user's side.
   * Both sides must confirm before merge is executed.
   * Confirmation code is sent to user's email or Telegram.
   * Requires authentication.
   */
  confirmMergeRequest: AccountMergeRequest;
  contactManager: Scalars['Boolean']['output'];
  createAcademyCourse: AcademyCourse;
  /** Create a new category (requires admin.access permission). */
  createCategory: Category;
  createCourseExam: CourseExam;
  createEvent: Event;
  createExamQuestion: ExamQuestionAdmin;
  /** Public: submit feedback message. accountId/telegramId from context if available. */
  createFeedback: FeedbackMessage;
  /** Create a home group (requires home_groups.manage permission). */
  createHomeGroup: HomeGroup;
  /** Create a new ministry (requires ministries.manage permission). */
  createMinistry: Ministry;
  createOrder: Order;
  /**
   * Create a long-lived PWA transfer token for reliable session transfer.
   * Unlike regular transfer tokens (5 min TTL, in-memory), these are:
   * - Stored in database (survives API restarts)
   * - Valid for 24 hours
   * - Can be used multiple times until explicitly consumed or expired
   *
   * Use this for PWA installation flow where timing is unpredictable.
   * Requires authentication.
   */
  createPWATransferToken: Scalars['String']['output'];
  /** Public: send message to pastor. Stored in DB; pastor notified via Telegram if configured. */
  createPastorMessage: PastorMessage;
  /** Create a new story (requires admin). */
  createStory: Story;
  createTicketType: TicketType;
  /**
   * Create a one-time transfer token for passing session to another context (e.g. Mini App -> PWA).
   * Token is valid for 5 minutes and can only be used once.
   * Requires authentication.
   */
  createTransferToken: Scalars['String']['output'];
  deleteAcademyCourse: Scalars['Boolean']['output'];
  /** Delete a category (requires admin.access permission). */
  deleteCategory: Scalars['Boolean']['output'];
  deleteEvent: Scalars['Boolean']['output'];
  deleteExamQuestion: Scalars['Boolean']['output'];
  /** Delete a home group (requires home_groups.manage permission). */
  deleteHomeGroup: Scalars['Boolean']['output'];
  /** Delete a home group schedule. */
  deleteHomeGroupSchedule: Scalars['Boolean']['output'];
  /** Delete a ministry (requires ministries.manage permission). */
  deleteMinistry: Scalars['Boolean']['output'];
  /** Delete a story (requires admin). */
  deleteStory: Scalars['Boolean']['output'];
  deleteTicketType: Scalars['Boolean']['output'];
  duplicateEvent: Event;
  /**
   * Exchange a short code (sent via email) for authentication.
   * Code is 6 characters, case-insensitive.
   * Only works for existing accounts that have email set (code was sent by requestMagicLink).
   */
  exchangeMagicCode: AuthResult;
  /**
   * Exchange a magic link token for authentication.
   * Creates account if it doesn't exist (for new users).
   */
  exchangeMagicLink: AuthResult;
  /**
   * Exchange a PWA transfer token for full authentication tokens.
   * The token is marked as used after exchange but remains in DB for auditing.
   */
  exchangePWATransferToken: AuthResult;
  /**
   * Exchange a transfer token for full authentication tokens.
   * The transfer token is invalidated after use.
   */
  exchangeTransferToken: AuthResult;
  /**
   * Generate a deep link for linking the current account to the Telegram bot.
   * Returns a URL like: https://t.me/bot_username?start=link_<encoded_account_id>
   * Requires authentication.
   */
  generateBotLinkUrl: Scalars['String']['output'];
  generateTickets: PaymentActionResult;
  issueTicketsForCash: PaymentActionResult;
  /** Join a home group (requires auth). */
  joinHomeGroup: HomeGroupMember;
  /** Leave a home group (requires auth). */
  leaveHomeGroup: Scalars['Boolean']['output'];
  /**
   * Link the current account to a Telegram bot interaction.
   * Called when user starts the bot with /start link_<accountId> parameter.
   * This allows the user to receive notifications via Telegram.
   *
   * Requires: telegramId from the bot interaction to match or link to account.
   */
  linkBot: Scalars['Boolean']['output'];
  /**
   * Link Telegram to current account (for email-only accounts).
   * Called when user authenticates via Telegram (widget or initData) and
   * already has an email-only session.
   *
   * Returns:
   * - LINKED: Success, Telegram linked to current account
   * - MERGE_REQUIRED: Telegram ID belongs to another account, merge needed
   * - ALREADY_LINKED: Current account already has this Telegram ID
   *
   * Requires authentication.
   */
  linkTelegramToAccount: LinkTelegramResponse;
  /** Login with email and password (for users who have set a password). */
  loginWithPassword: AuthResult;
  markTicketUsed: AdminTicket;
  proceedToPayment: Order;
  /**
   * Refresh access token using refresh token.
   * Call this when access token expires.
   *
   * Returns new tokens (both access and refresh are rotated).
   */
  refreshToken: AuthTokens;
  regenerateTicket: PaymentActionResult;
  regenerateTickets: PaymentActionResult;
  rejectPayment: PaymentActionResult;
  removeEventOrganizer: Scalars['Boolean']['output'];
  /**
   * Remove RSVP from an event.
   * Requires authentication.
   */
  removeEventRsvp: Scalars['Boolean']['output'];
  /** Remove a member from a ministry (requires ministries.manage permission). */
  removeMinistryMember: Scalars['Boolean']['output'];
  reorderExamQuestions: Scalars['Boolean']['output'];
  /**
   * Request a magic link (short code) to be sent to the specified email.
   * Only sends if an account with this email already exists.
   * If no account: returns EMAIL_NOT_FOUND (user should use Telegram / mini app).
   * Rate limited: max 3 requests per hour per email.
   */
  requestMagicLink: RequestMagicLinkResult;
  /**
   * Resend confirmation code for merge request.
   * Requires authentication.
   */
  resendMergeConfirmationCode: Scalars['Boolean']['output'];
  resendTicket: PaymentActionResult;
  resendTickets: PaymentActionResult;
  selectPaymentCurrency: Order;
  sendCourseInvite: SendCourseInviteResult;
  /**
   * Set RSVP status for an event.
   * Creates new RSVP or updates existing one.
   * Requires authentication.
   */
  setEventRsvp: EventRsvp;
  /**
   * Set password for the current account (email must be verified).
   * Allows users to login with password instead of magic link.
   * Requires authentication.
   */
  setPassword: Scalars['Boolean']['output'];
  startExamAttempt: ExamAttempt;
  /** Toggle favorite status for a home group (requires auth). */
  toggleFavoriteHomeGroup: Scalars['Boolean']['output'];
  trackCourseVisit: Scalars['Boolean']['output'];
  updateAcademyCourse: AcademyCourse;
  /** Update an existing category (requires admin.access permission). */
  updateCategory: Category;
  /** Admin: create or update church info. Creates record if none exists. */
  updateChurchInfo: ChurchInfo;
  updateCourseExam: CourseExam;
  updateEvent: Event;
  updateExamQuestion: ExamQuestionAdmin;
  /** Update a home group (requires home_groups.manage or being the leader). */
  updateHomeGroup: HomeGroup;
  /** Update a home group schedule. */
  updateHomeGroupSchedule: HomeGroupSchedule;
  /** Admin: create or update home groups page config. */
  updateHomeGroupsPageConfig: HomeGroupsPageConfig;
  /** Update an existing ministry (requires ministries.manage permission). */
  updateMinistry: Ministry;
  /** Update a member's role in a ministry (requires ministries.manage permission). */
  updateMinistryMember: MinistryMember;
  /** Update an existing story (requires admin). */
  updateStory: Story;
  updateTicketType: TicketType;
  /**
   * Verify email and link it to current account.
   * Completes the addEmailToAccount flow.
   * Requires authentication.
   */
  verifyEmailLink: Scalars['Boolean']['output'];
  vote: GenderParty;
};


export type MutationAddEmailToAccountArgs = {
  email: Scalars['String']['input'];
};


export type MutationAddEventOrganizerArgs = {
  eventId: Scalars['ID']['input'];
  input: EventOrganizerInput;
};


export type MutationAddHomeGroupScheduleArgs = {
  homeGroupId: Scalars['ID']['input'];
  input: HomeGroupScheduleInput;
};


export type MutationAddMinistryMemberArgs = {
  input: AddMinistryMemberInput;
  ministryId: Scalars['ID']['input'];
};


export type MutationAdminAddAllEventTicketsArgs = {
  raffleId: Scalars['ID']['input'];
};


export type MutationAdminAddGenderPartyPhotoArgs = {
  genderPartyId: Scalars['ID']['input'];
  input: GenderPartyPhotoInput;
};


export type MutationAdminAddPrizeArgs = {
  input: PrizeInput;
  raffleId: Scalars['ID']['input'];
};


export type MutationAdminAssignRoleArgs = {
  accountId: Scalars['ID']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleCode: Scalars['String']['input'];
};


export type MutationAdminCloseGenderPartyVotingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminCompleteRaffleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminCopyRaffleArgs = {
  id: Scalars['ID']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAdminCreateGenderPartyArgs = {
  input: GenderPartyInput;
};


export type MutationAdminCreateRaffleArgs = {
  eventId: Scalars['ID']['input'];
  input: RaffleInput;
};


export type MutationAdminDeleteGenderPartyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteGenderPartyPhotoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeletePrizeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteRaffleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDrawPrizeArgs = {
  prizeId: Scalars['ID']['input'];
  raffleId: Scalars['ID']['input'];
};


export type MutationAdminGrantPermissionArgs = {
  accountId: Scalars['ID']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissionCode: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminHideGenderPartyResultsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminNextPrizeArgs = {
  raffleId: Scalars['ID']['input'];
};


export type MutationAdminOpenGenderPartyVotingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminReadyRaffleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminReopenGenderPartyVotingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminReorderGenderPartyPhotosArgs = {
  genderPartyId: Scalars['ID']['input'];
  photoIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminReorderPrizesArgs = {
  prizeIds: Array<Scalars['ID']['input']>;
  raffleId: Scalars['ID']['input'];
};


export type MutationAdminResetTestGenderPartyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminResetTestRaffleArgs = {
  raffleId: Scalars['ID']['input'];
};


export type MutationAdminRevealGenderPartyAnswerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRevealGenderPartyResultsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRevokePermissionArgs = {
  accountId: Scalars['ID']['input'];
  permissionCode: Scalars['String']['input'];
};


export type MutationAdminRevokeRoleArgs = {
  accountId: Scalars['ID']['input'];
  roleCode: Scalars['String']['input'];
};


export type MutationAdminSendOrderMessageArgs = {
  attachmentKind?: InputMaybe<MessageAttachmentKind>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonTextEvent?: InputMaybe<Scalars['String']['input']>;
  linkEventId?: InputMaybe<Scalars['ID']['input']>;
  linkOrderId?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationAdminSetFeedbackConfigArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationAdminSetPastorConfigArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationAdminSetRaffleTicketsArgs = {
  raffleId: Scalars['ID']['input'];
  ticketIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminShowCompletedArgs = {
  raffleId: Scalars['ID']['input'];
};


export type MutationAdminShowWinnerArgs = {
  prizeId: Scalars['ID']['input'];
  raffleId: Scalars['ID']['input'];
};


export type MutationAdminStartRaffleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminUnreadyGenderPartyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminUnreadyRaffleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminUpdateFeedbackArgs = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<FeedbackStatus>;
};


export type MutationAdminUpdateGenderPartyArgs = {
  id: Scalars['ID']['input'];
  input: GenderPartyUpdateInput;
};


export type MutationAdminUpdatePrizeArgs = {
  id: Scalars['ID']['input'];
  input: PrizeInput;
};


export type MutationAdminUpdateRaffleArgs = {
  id: Scalars['ID']['input'];
  input: RaffleInput;
};


export type MutationAnswerExamQuestionArgs = {
  answer: Scalars['String']['input'];
  attemptId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationApprovePaymentArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationAuthenticateWithInitDataArgs = {
  initData: Scalars['String']['input'];
};


export type MutationAuthenticateWithWidgetArgs = {
  data: TelegramWidgetInput;
};


export type MutationCancelMergeRequestArgs = {
  mergeRequestId: Scalars['ID']['input'];
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationConfirmEventRsvpArgs = {
  accountId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};


export type MutationConfirmMergeRequestArgs = {
  confirmationCode: Scalars['String']['input'];
  mergeRequestId: Scalars['ID']['input'];
};


export type MutationContactManagerArgs = {
  message: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationCreateAcademyCourseArgs = {
  input: CreateAcademyCourseInput;
};


export type MutationCreateCategoryArgs = {
  input: CategoryInput;
};


export type MutationCreateCourseExamArgs = {
  input: CreateCourseExamInput;
};


export type MutationCreateEventArgs = {
  input: EventInput;
};


export type MutationCreateExamQuestionArgs = {
  input: CreateExamQuestionInput;
};


export type MutationCreateFeedbackArgs = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationCreateHomeGroupArgs = {
  input: HomeGroupInput;
};


export type MutationCreateMinistryArgs = {
  input: MinistryInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreatePastorMessageArgs = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationCreateStoryArgs = {
  input: StoryInput;
};


export type MutationCreateTicketTypeArgs = {
  eventId: Scalars['ID']['input'];
  input: TicketTypeInput;
};


export type MutationDeleteAcademyCourseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExamQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHomeGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHomeGroupScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationDeleteMinistryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTicketTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExchangeMagicCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationExchangeMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationExchangePwaTransferTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationExchangeTransferTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationGenerateTicketsArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationIssueTicketsForCashArgs = {
  accountId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  items: Array<CashTicketItemInput>;
};


export type MutationJoinHomeGroupArgs = {
  homeGroupId: Scalars['ID']['input'];
};


export type MutationLeaveHomeGroupArgs = {
  homeGroupId: Scalars['ID']['input'];
};


export type MutationLinkBotArgs = {
  telegramId: Scalars['String']['input'];
};


export type MutationLinkTelegramToAccountArgs = {
  telegramId: Scalars['String']['input'];
};


export type MutationLoginWithPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkTicketUsedArgs = {
  ticketId: Scalars['ID']['input'];
};


export type MutationProceedToPaymentArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegenerateTicketArgs = {
  options?: InputMaybe<RegenerateTicketsInput>;
  ticketId: Scalars['ID']['input'];
};


export type MutationRegenerateTicketsArgs = {
  options?: InputMaybe<RegenerateTicketsInput>;
  orderId: Scalars['ID']['input'];
};


export type MutationRejectPaymentArgs = {
  orderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRemoveEventOrganizerArgs = {
  organizerId: Scalars['ID']['input'];
};


export type MutationRemoveEventRsvpArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationRemoveMinistryMemberArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationReorderExamQuestionsArgs = {
  examId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};


export type MutationRequestMagicLinkArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendMergeConfirmationCodeArgs = {
  mergeRequestId: Scalars['ID']['input'];
};


export type MutationResendTicketArgs = {
  options?: InputMaybe<ResendTicketsInput>;
  ticketId: Scalars['ID']['input'];
};


export type MutationResendTicketsArgs = {
  options?: InputMaybe<ResendTicketsInput>;
  orderId: Scalars['ID']['input'];
};


export type MutationSelectPaymentCurrencyArgs = {
  currency: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationSendCourseInviteArgs = {
  accountIds: Array<Scalars['ID']['input']>;
  courseId: Scalars['ID']['input'];
};


export type MutationSetEventRsvpArgs = {
  eventId: Scalars['ID']['input'];
  guestCount?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notifyOnChanges?: InputMaybe<Scalars['Boolean']['input']>;
  status: RsvpStatus;
};


export type MutationSetPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationStartExamAttemptArgs = {
  examId: Scalars['ID']['input'];
};


export type MutationToggleFavoriteHomeGroupArgs = {
  homeGroupId: Scalars['ID']['input'];
};


export type MutationTrackCourseVisitArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationUpdateAcademyCourseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAcademyCourseInput;
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['ID']['input'];
  input: CategoryInput;
};


export type MutationUpdateChurchInfoArgs = {
  input: ChurchInfoInput;
};


export type MutationUpdateCourseExamArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCourseExamInput;
};


export type MutationUpdateEventArgs = {
  id: Scalars['ID']['input'];
  input: EventInput;
};


export type MutationUpdateExamQuestionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExamQuestionInput;
};


export type MutationUpdateHomeGroupArgs = {
  id: Scalars['ID']['input'];
  input: HomeGroupInput;
};


export type MutationUpdateHomeGroupScheduleArgs = {
  input: HomeGroupScheduleInput;
  scheduleId: Scalars['ID']['input'];
};


export type MutationUpdateHomeGroupsPageConfigArgs = {
  input: HomeGroupsPageConfigInput;
};


export type MutationUpdateMinistryArgs = {
  id: Scalars['ID']['input'];
  input: MinistryInput;
};


export type MutationUpdateMinistryMemberArgs = {
  memberId: Scalars['ID']['input'];
  role: MinistryRole;
};


export type MutationUpdateStoryArgs = {
  id: Scalars['ID']['input'];
  input: StoryInput;
};


export type MutationUpdateTicketTypeArgs = {
  id: Scalars['ID']['input'];
  input: TicketTypeUpdateInput;
};


export type MutationVerifyEmailLinkArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationVoteArgs = {
  genderPartyId: Scalars['ID']['input'];
  vote: GenderVote;
};

export type Order = {
  accountId: Scalars['ID']['output'];
  conversationMessages: Array<OrderConversationMessage>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  event: Event;
  eventId: Scalars['ID']['output'];
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  fees: Array<OrderFee>;
  feesTotal: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  manualPayment: Maybe<ManualPayment>;
  payments: Array<Payment>;
  pricingOptions: Array<OrderPricing>;
  selectedPricing: Maybe<OrderPricing>;
  status: OrderStatus;
  subtotal: Scalars['Decimal']['output'];
  tickets: Array<Ticket>;
  totalAmount: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderConversationMessage = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isFromUser: Scalars['Boolean']['output'];
  messageText: Scalars['String']['output'];
};

export type OrderFee = {
  amount: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: FeeType;
};

export type OrderItem = {
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  ticketType: TicketType;
  ticketTypeId: Scalars['ID']['output'];
  totalPrice: Scalars['Decimal']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

export type OrderItemInput = {
  quantity: Scalars['Int']['input'];
  ticketTypeId: Scalars['ID']['input'];
};

export type OrderPricing = {
  currency: Scalars['String']['output'];
  fees: Array<OrderPricingFee>;
  feesTotal: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  isSelected: Scalars['Boolean']['output'];
  subtotal: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type OrderPricingFee = {
  amount: Scalars['Decimal']['output'];
  calculation: FeeCalculation;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: FeeType;
};

export enum OrderStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  PendingVerification = 'PENDING_VERIFICATION',
  Rejected = 'REJECTED',
  TicketsPendingSend = 'TICKETS_PENDING_SEND',
  TicketIssued = 'TICKET_ISSUED',
  Verified = 'VERIFIED'
}

/** Organizer role. */
export enum OrganizerRole {
  Helper = 'HELPER',
  Organizer = 'ORGANIZER',
  Owner = 'OWNER'
}

/** Admin view: pastor config with account info for display/selection. */
export type PastorConfigAdmin = {
  account: Maybe<AdminAccount>;
  accountId: Scalars['ID']['output'];
};

export type PastorMessage = {
  accountId: Maybe<Scalars['ID']['output']>;
  authorName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  telegramId: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type Payment = {
  amount: Scalars['Decimal']['output'];
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  failureReason: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  provider: PaymentProvider;
  providerPaymentId: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
};

export type PaymentActionResult = {
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PaymentAnalytics = {
  averageOrderValue: Scalars['Decimal']['output'];
  byCurrency: Array<PaymentCurrencyStats>;
  byProvider: Array<PaymentProviderStats>;
  byStatus: Array<PaymentStatusStats>;
  pendingCount: Scalars['Int']['output'];
  primaryCurrency: Scalars['String']['output'];
  totalOrders: Scalars['Int']['output'];
  totalRevenue: Scalars['Decimal']['output'];
};

export type PaymentAnalyticsFilter = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentCurrencyStats = {
  amount: Scalars['Decimal']['output'];
  count: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export enum PaymentProvider {
  Exgo = 'EXGO',
  Manual = 'MANUAL',
  Stripe = 'STRIPE',
  Yoomoney = 'YOOMONEY'
}

export type PaymentProviderStats = {
  amount: Scalars['Decimal']['output'];
  count: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  successRate: Scalars['Float']['output'];
};

export type PaymentRequisites = {
  account: Scalars['String']['output'];
  bank: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum PaymentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED'
}

export type PaymentStatusStats = {
  amount: Scalars['Decimal']['output'];
  count: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PendingPayment = {
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  event: Event;
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  receiptUploadedAt: Maybe<Scalars['DateTime']['output']>;
  receiptUrl: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  totalAmount: Scalars['Decimal']['output'];
};

export type PermissionInfo = {
  category: Scalars['String']['output'];
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Prize = {
  description: Maybe<Scalars['String']['output']>;
  draw: Maybe<Draw>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isDrawn: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  raffleId: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type PrizeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type Query = {
  _empty: Maybe<Scalars['String']['output']>;
  academyCourse: Maybe<AcademyCourse>;
  academyCourses: Array<AcademyCourse>;
  activeGenderParties: Array<GenderParty>;
  adminAcademyCourse: Maybe<AcademyCourse>;
  adminAcademyCourses: Array<AcademyCourse>;
  adminAccounts: Array<AdminAccount>;
  /** Admin: get church info for editing (may be null if not created yet). */
  adminChurchInfo: Maybe<ChurchInfo>;
  adminCourseAnalytics: CourseAnalytics;
  adminCourseExam: Maybe<CourseExam>;
  adminDashboardStats: AdminDashboardStats;
  adminEvent: Maybe<Event>;
  adminEventPendingRsvps: Array<EventRsvp>;
  adminEventTicketsForRaffle: Array<RaffleTicket>;
  adminEvents: Array<Event>;
  adminEventsWithStats: Array<AdminEventWithStats>;
  adminExamQuestions: Array<ExamQuestionAdmin>;
  /** Admin: who receives notifications for new feedback. */
  adminFeedbackConfig: Maybe<FeedbackConfigAdmin>;
  /** Admin: list feedback messages with optional status filter. */
  adminFeedbackMessages: Array<FeedbackMessage>;
  adminGenderParties: Array<GenderParty>;
  adminGenderParty: Maybe<GenderParty>;
  adminGenderPartyEvents: Array<GenderPartyEventSummary>;
  adminGenderPartyVotes: Array<GenderPartyVoteRecord>;
  adminHomeGroups: Array<HomeGroup>;
  /** Admin: get config for editing. */
  adminHomeGroupsPageConfig: Maybe<HomeGroupsPageConfig>;
  /** Admin list: all ministries with optional filter. Requires ministries.manage or admin. */
  adminMinistries: Array<Ministry>;
  adminOrder: Maybe<AdminOrder>;
  adminOrders: AdminOrdersResult;
  adminOrdersByAccount: AdminOrdersResult;
  adminOrdersStats: AdminOrdersStats;
  adminOverviewStats: AdminOverviewStats;
  /** Admin: get current pastor config (who receives messages). */
  adminPastorConfig: Maybe<PastorConfigAdmin>;
  /** Admin: list messages sent to pastor. */
  adminPastorMessages: Array<PastorMessage>;
  adminPermissions: Array<PermissionInfo>;
  adminRaffle: Maybe<Raffle>;
  adminRaffleEvents: Array<RaffleEventSummary>;
  adminRaffleTickets: Array<RaffleTicket>;
  adminRaffles: Array<Raffle>;
  adminRoles: Array<RoleInfo>;
  /** Admin list: all stories with optional filter. Requires admin. */
  adminStories: Array<Story>;
  adminTicketEvents: Array<TicketEventSummary>;
  adminTickets: AdminTicketsResult;
  adminUpcomingEvents: Array<AdminEventWithStats>;
  adminUserAccess: Maybe<UserWithAccess>;
  adminUserConversation: Array<UserConversationMessage>;
  adminUsersWithAccess: Array<UserWithAccess>;
  announcementEvents: Array<Event>;
  /** List all active categories (top-level only by default). */
  categories: Array<Category>;
  /** Get category by ID. */
  category: Maybe<Category>;
  /** Get category by code. */
  categoryByCode: Maybe<Category>;
  /** Public: get active church info (single record for app). */
  churchInfo: Maybe<ChurchInfo>;
  event: Maybe<Event>;
  events: Array<Event>;
  feeConfigurations: Array<FeeConfiguration>;
  genderParty: Maybe<GenderParty>;
  /** Get home group by ID. */
  homeGroup: Maybe<HomeGroup>;
  /** List home groups with optional filters. */
  homeGroups: Array<HomeGroup>;
  /** Public: get active home groups page config. */
  homeGroupsPageConfig: Maybe<HomeGroupsPageConfig>;
  /** Current authenticated user. */
  me: Maybe<Account>;
  /** List all active ministries. */
  ministries: Array<Ministry>;
  /** Get ministry by ID. */
  ministry: Maybe<Ministry>;
  /** Get ministry by code. */
  ministryByCode: Maybe<Ministry>;
  /** Get current user's favorite home groups (requires auth). */
  myFavoriteHomeGroups: Array<HomeGroup>;
  /** Get current user's home groups (requires auth). */
  myHomeGroups: Array<HomeGroup>;
  myRaffleTickets: Array<RaffleTicket>;
  order: Maybe<Order>;
  orders: Array<Order>;
  paymentAnalytics: PaymentAnalytics;
  paymentRequisites: Array<PaymentRequisites>;
  /**
   * Get pending merge request for current user (if any).
   * Returns null if no pending merge request exists.
   * Requires authentication.
   */
  pendingMergeRequest: Maybe<AccountMergeRequest>;
  pendingPayments: Array<PendingPayment>;
  raffle: Maybe<Raffle>;
  searchAccounts: Array<AdminAccount>;
  /** Public list: active stories, published and not expired. Ordered by sortOrder. */
  stories: Array<Story>;
  /**
   * Get story by ID.
   * If preview=true and user is admin, returns the story even if inactive/unpublished.
   */
  story: Maybe<Story>;
  ticket: Maybe<Ticket>;
  tickets: Array<Ticket>;
  validateTicket: TicketValidationResult;
};


export type QueryAcademyCourseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminAcademyCourseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminCourseAnalyticsArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryAdminCourseExamArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryAdminEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminEventPendingRsvpsArgs = {
  eventId: Scalars['ID']['input'];
};


export type QueryAdminEventTicketsForRaffleArgs = {
  eventId: Scalars['ID']['input'];
  filter?: InputMaybe<TicketFilter>;
};


export type QueryAdminEventsWithStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminExamQuestionsArgs = {
  examId: Scalars['ID']['input'];
};


export type QueryAdminFeedbackMessagesArgs = {
  filter?: InputMaybe<AdminFeedbackMessagesFilter>;
};


export type QueryAdminGenderPartiesArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminGenderPartyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminGenderPartyVotesArgs = {
  genderPartyId: Scalars['ID']['input'];
};


export type QueryAdminHomeGroupsArgs = {
  filter?: InputMaybe<AdminHomeGroupsFilter>;
};


export type QueryAdminMinistriesArgs = {
  filter?: InputMaybe<AdminMinistriesFilter>;
};


export type QueryAdminOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminOrdersArgs = {
  filter?: InputMaybe<AdminOrdersFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminOrdersByAccountArgs = {
  accountId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminRaffleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminRaffleTicketsArgs = {
  raffleId: Scalars['ID']['input'];
};


export type QueryAdminRafflesArgs = {
  eventId: Scalars['ID']['input'];
};


export type QueryAdminStoriesArgs = {
  filter?: InputMaybe<AdminStoriesFilter>;
};


export type QueryAdminTicketsArgs = {
  filter?: InputMaybe<AdminTicketsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminUpcomingEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminUserAccessArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAdminUserConversationArgs = {
  accountId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminUsersWithAccessArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  permissionCode?: InputMaybe<Scalars['String']['input']>;
  roleCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoriesArgs = {
  includeChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCategoryByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEventsArgs = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  homeGroupId?: InputMaybe<Scalars['ID']['input']>;
  onlyWithMyRsvp?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenderPartyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeGroupsArgs = {
  filter?: InputMaybe<HomeGroupFilter>;
};


export type QueryMinistryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMinistryByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryMyRaffleTicketsArgs = {
  raffleId: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentAnalyticsArgs = {
  filter?: InputMaybe<PaymentAnalyticsFilter>;
};


export type QueryRaffleArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryStoryArgs = {
  id: Scalars['ID']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryValidateTicketArgs = {
  ticketNumber: Scalars['String']['input'];
};

export enum QuestionType {
  Matching = 'MATCHING',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Ordering = 'ORDERING',
  SingleChoice = 'SINGLE_CHOICE',
  TextInput = 'TEXT_INPUT',
  TrueFalse = 'TRUE_FALSE'
}

export type Raffle = {
  createdAt: Scalars['DateTime']['output'];
  currentPrize: Maybe<Prize>;
  description: Maybe<Scalars['String']['output']>;
  draws: Array<Draw>;
  event: Event;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isTest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prizes: Array<Prize>;
  status: RaffleStatus;
  ticketCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RaffleEventSummary = {
  activeRafflesCount: Scalars['Int']['output'];
  coverImage: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  rafflesCount: Scalars['Int']['output'];
  startDate: Maybe<Scalars['DateTime']['output']>;
  ticketTypesCount: Scalars['Int']['output'];
  ticketsCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type RaffleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export enum RaffleStatus {
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Ready = 'READY'
}

export type RaffleTicket = {
  accountId: Scalars['ID']['output'];
  accountName: Scalars['String']['output'];
  accountUsername: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  isUsed: Scalars['Boolean']['output'];
  ticketNumber: Scalars['String']['output'];
  ticketTypeName: Scalars['String']['output'];
};

export type RaffleTicketInfo = {
  accountId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ticketNumber: Scalars['String']['output'];
  winnerName: Scalars['String']['output'];
  winnerUsername: Maybe<Scalars['String']['output']>;
};

export type RegenerateTicketsInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  imageOnly?: Scalars['Boolean']['input'];
  sendToUser?: Scalars['Boolean']['input'];
};

/**
 * Result of requesting a magic link (short code sent to email).
 * Email login is only for accounts that already have email set.
 */
export enum RequestMagicLinkReason {
  /** No account with this email; use Telegram to sign in first. */
  EmailNotFound = 'EMAIL_NOT_FOUND',
  /** Too many requests; try again later. */
  RateLimited = 'RATE_LIMITED',
  /** Code sent to email (account exists). */
  Sent = 'SENT'
}

export type RequestMagicLinkResult = {
  reason: RequestMagicLinkReason;
  sent: Scalars['Boolean']['output'];
};

export type ResendTicketsInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
};

/** User role. */
export type Role = {
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type RoleInfo = {
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<PermissionInfo>;
};

/** Aggregated RSVP counts for an event. */
export type RsvpCounts = {
  going: Scalars['Int']['output'];
  interested: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** How the RSVP was created. */
export enum RsvpSource {
  HomeGroup = 'HOME_GROUP',
  Manual = 'MANUAL',
  Registration = 'REGISTRATION',
  TicketPurchase = 'TICKET_PURCHASE'
}

/** RSVP status options. */
export enum RsvpStatus {
  Going = 'GOING',
  Interested = 'INTERESTED',
  NotGoing = 'NOT_GOING',
  Pending = 'PENDING'
}

export type SendCourseInviteResult = {
  message: Maybe<Scalars['String']['output']>;
  sentCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export enum ShowResultsMode {
  AfterVote = 'AFTER_VOTE',
  Always = 'ALWAYS',
  OnReveal = 'ON_REVEAL'
}

/** Story: one media item (image or video) for the home stories strip. */
export type Story = {
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  linkUrl: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  sortOrder: Scalars['Int']['output'];
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoUrl: Maybe<Scalars['String']['output']>;
};

/** Input for creating/updating a story. */
export type StoryInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Telegram Login Widget data. */
export type TelegramWidgetInput = {
  auth_date: Scalars['Int']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  photo_url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Ticket = {
  accountId: Scalars['ID']['output'];
  event: Event;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  issuedAt: Scalars['DateTime']['output'];
  orderId: Scalars['ID']['output'];
  status: TicketStatus;
  ticketNumber: Scalars['String']['output'];
  ticketType: TicketType;
  ticketTypeId: Scalars['ID']['output'];
  usedAt: Maybe<Scalars['DateTime']['output']>;
};

export type TicketEventSummary = {
  coverImage: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  startDate: Maybe<Scalars['DateTime']['output']>;
  ticketTypesCount: Scalars['Int']['output'];
  ticketsCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  usedTicketsCount: Scalars['Int']['output'];
};

export enum TicketFilter {
  All = 'ALL',
  Paid = 'PAID',
  Used = 'USED'
}

export enum TicketStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Used = 'USED'
}

export type TicketType = {
  available: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  fees: Array<TicketTypeFee>;
  feesBreakdown: Array<FeeBreakdown>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxQuantity: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  prices: Array<TicketTypePrice>;
  soldCount: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  totalPrice: Scalars['Decimal']['output'];
};


export type TicketTypeFeesBreakdownArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};


export type TicketTypeTotalPriceArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type TicketTypeFee = {
  feeConfiguration: FeeConfiguration;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  overrideAmount: Maybe<Scalars['Decimal']['output']>;
};

export type TicketTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  prices: Array<TicketTypePriceInput>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketTypePrice = {
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Decimal']['output'];
};

export type TicketTypePriceInput = {
  currency: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
};

export type TicketTypeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prices?: InputMaybe<Array<TicketTypePriceInput>>;
  serviceFeeConfigId?: InputMaybe<Scalars['ID']['input']>;
  serviceFeePrices?: InputMaybe<Array<FeeConfigurationPriceInput>>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketValidationResult = {
  alreadyUsedAt: Maybe<Scalars['DateTime']['output']>;
  customerName: Maybe<Scalars['String']['output']>;
  event: Maybe<Event>;
  isValid: Scalars['Boolean']['output'];
  message: Maybe<Scalars['String']['output']>;
  ticket: Maybe<AdminTicket>;
};

export type UpdateAcademyCourseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseExamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  passingScore?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateExamQuestionInput = {
  correctAnswer?: InputMaybe<Scalars['String']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<ExamOptionInput>>;
  points?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<QuestionType>;
};

export type UsefulChat = {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UsefulChatInput = {
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UserConversationMessage = {
  accountId: Scalars['ID']['output'];
  buttonText: Maybe<Scalars['String']['output']>;
  buttonTextEvent: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  linkEventId: Maybe<Scalars['ID']['output']>;
  linkOrderId: Maybe<Scalars['ID']['output']>;
  messageText: Scalars['String']['output'];
  orderId: Maybe<Scalars['ID']['output']>;
  sentBy: Maybe<Customer>;
  sentByAccountId: Maybe<Scalars['ID']['output']>;
};

export type UserPermissionInfo = {
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  granted: Scalars['Boolean']['output'];
  grantedAt: Scalars['DateTime']['output'];
  grantedBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissionCode: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
  permissionName: Scalars['String']['output'];
  reason: Maybe<Scalars['String']['output']>;
};

export type UserRoleInfo = {
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  grantedAt: Scalars['DateTime']['output'];
  grantedBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  roleCode: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
};

export type UserWithAccess = {
  directPermissions: Array<UserPermissionInfo>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  roles: Array<UserRoleInfo>;
  telegramId: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type EventBaseFragment = { id: string, title: string, subtitle: string | null, description: string | null, venue: string | null, startsAt: string, imageUrl: string | null, isActive: boolean };

export type EventTicketTypeFragment = { id: string, name: string, description: string | null, price: string, totalPrice: string, currency: string, maxQuantity: number | null, soldCount: number, available: number | null };

export type EventFullFragment = { address: string | null, mapsUrl: string | null, endsAt: string | null, videoUrl: string | null, streamYoutubeUrl: string | null, streamVkUrl: string | null, telegramChatUrl: string | null, inviteText: string | null, slogan: string | null, program: string | null, requiresRsvpConfirmation: boolean, hasMyTickets: boolean, id: string, title: string, subtitle: string | null, description: string | null, venue: string | null, startsAt: string, imageUrl: string | null, isActive: boolean, myRsvp: { id: string, status: RsvpStatus } | null, categories: Array<{ id: string, name: string, code: string, color: string | null }>, ticketTypes: Array<{ id: string, name: string, description: string | null, price: string, totalPrice: string, currency: string, maxQuantity: number | null, soldCount: number, available: number | null, feesBreakdown: Array<{ name: string, type: FeeType, amount: string }> }>, homeGroup: { id: string, name: string } | null };

export type OrderBaseFragment = { id: string, status: OrderStatus, totalAmount: string, currency: string, createdAt: string };

export type OrderItemFragment = { id: string, quantity: number, unitPrice: string, totalPrice: string, ticketType: { id: string, name: string } };

export type OrderFeeFragment = { id: string, name: string, type: FeeType, amount: string };

export type OrderPricingFeeFragment = { id: string, name: string, type: FeeType, calculation: FeeCalculation, amount: string };

export type OrderPricingFragment = { id: string, currency: string, subtotal: string, feesTotal: string, total: string, isSelected: boolean, fees: Array<{ id: string, name: string, type: FeeType, calculation: FeeCalculation, amount: string }> };

export type OrderFullFragment = { subtotal: string, feesTotal: string, expiresAt: string | null, id: string, status: OrderStatus, totalAmount: string, currency: string, createdAt: string, event: { id: string, title: string, startsAt: string, venue: string | null, imageUrl: string | null }, items: Array<{ id: string, quantity: number, unitPrice: string, totalPrice: string, ticketType: { id: string, name: string } }>, fees: Array<{ id: string, name: string, type: FeeType, amount: string }>, pricingOptions: Array<{ id: string, currency: string, subtotal: string, feesTotal: string, total: string, isSelected: boolean, fees: Array<{ id: string, name: string, type: FeeType, calculation: FeeCalculation, amount: string }> }>, selectedPricing: { id: string, currency: string, subtotal: string, feesTotal: string, total: string, fees: Array<{ id: string, name: string, type: FeeType, calculation: FeeCalculation, amount: string }> } | null, manualPayment: { status: string, receiptUrl: string | null } | null, tickets: Array<{ id: string, ticketNumber: string, ticketType: { name: string }, event: { id: string, title: string, startsAt: string, venue: string | null } }>, conversationMessages: Array<{ id: string, messageText: string, createdAt: string, isFromUser: boolean }> };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { createOrder: { id: string, status: OrderStatus, totalAmount: string, currency: string } };

export type ProceedToPaymentMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ProceedToPaymentMutation = { proceedToPayment: { id: string, status: OrderStatus } };

export type CancelOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type CancelOrderMutation = { cancelOrder: { id: string, status: OrderStatus } };

export type SelectPaymentCurrencyMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
}>;


export type SelectPaymentCurrencyMutation = { selectPaymentCurrency: { id: string, currency: string, subtotal: string, feesTotal: string, totalAmount: string, pricingOptions: Array<{ id: string, currency: string, subtotal: string, feesTotal: string, total: string, isSelected: boolean, fees: Array<{ id: string, name: string, type: FeeType, calculation: FeeCalculation, amount: string }> }>, selectedPricing: { id: string, currency: string, subtotal: string, feesTotal: string, total: string, fees: Array<{ id: string, name: string, type: FeeType, calculation: FeeCalculation, amount: string }> } | null } };

export type ContactManagerMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type ContactManagerMutation = { contactManager: boolean };

export type SetEventRsvpMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  status: RsvpStatus;
}>;


export type SetEventRsvpMutation = { setEventRsvp: { id: string, status: RsvpStatus } };

export type RemoveEventRsvpMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type RemoveEventRsvpMutation = { removeEventRsvp: boolean };

export type JoinHomeGroupMutationVariables = Exact<{
  homeGroupId: Scalars['ID']['input'];
}>;


export type JoinHomeGroupMutation = { joinHomeGroup: { id: string } };

export type CreateFeedbackMutationVariables = Exact<{
  text: Scalars['String']['input'];
  authorName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFeedbackMutation = { createFeedback: { id: string, createdAt: string } };

export type CreatePastorMessageMutationVariables = Exact<{
  text: Scalars['String']['input'];
  authorName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePastorMessageMutation = { createPastorMessage: { id: string, createdAt: string } };

export type ChurchInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ChurchInfoQuery = { churchInfo: { id: string, title: string | null, imageUrl: string | null, welcomeText: string | null, scheduleText: string | null, address: string | null, mapUrl: string | null, parkingText: string | null, phone: string | null, email: string | null, companyName: string | null, companyDetails: string | null, isActive: boolean, usefulChats: Array<{ label: string, url: string }> } | null };

export type HomeGroupsPageConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeGroupsPageConfigQuery = { homeGroupsPageConfig: { id: string, title: string | null, bodyText: string | null, imageUrl: string | null, isActive: boolean } | null };

export type HomeGroupsQueryVariables = Exact<{
  filter?: InputMaybe<HomeGroupFilter>;
}>;


export type HomeGroupsQuery = { homeGroups: Array<{ id: string, name: string, description: string | null, location: string | null, isOpen: boolean, isActive: boolean, memberCount: number, imageUrl: string | null, mapsUrl: string | null, leader: { id: string, firstName: string | null, lastName: string | null }, schedules: Array<{ id: string, dayOfWeek: DayOfWeek, startTime: string, endTime: string | null, isActive: boolean }> }> };

export type HomeGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HomeGroupQuery = { homeGroup: { id: string, name: string, description: string | null, isOpen: boolean, isMember: boolean, memberCount: number, imageUrl: string | null, leader: { id: string, firstName: string | null, lastName: string | null, username: string | null }, coLeader: { id: string, firstName: string | null, lastName: string | null, username: string | null } | null, schedules: Array<{ id: string, dayOfWeek: DayOfWeek, startTime: string, endTime: string | null, isActive: boolean }> } | null };

export type EventsQueryVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  onlyWithMyRsvp?: InputMaybe<Scalars['Boolean']['input']>;
  homeGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EventsQuery = { events: Array<{ id: string, status: EventStatus, isActive: boolean, title: string, subtitle: string | null, description: string | null, venue: string | null, address: string | null, mapsUrl: string | null, startsAt: string, imageUrl: string | null, videoUrl: string | null, streamYoutubeUrl: string | null, streamVkUrl: string | null, telegramChatUrl: string | null, inviteText: string | null, slogan: string | null, program: string | null, requiresRsvpConfirmation: boolean, hasMyTickets: boolean, myRsvp: { id: string, status: RsvpStatus } | null, categories: Array<{ id: string, name: string, code: string, color: string | null }>, ticketTypes: Array<{ id: string, name: string, description: string | null, price: string, totalPrice: string, currency: string, maxQuantity: number | null, soldCount: number, available: number | null }> }> };

export type EventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventQuery = { event: { id: string, title: string, subtitle: string | null, description: string | null, venue: string | null, address: string | null, mapsUrl: string | null, startsAt: string, endsAt: string | null, imageUrl: string | null, videoUrl: string | null, streamYoutubeUrl: string | null, streamVkUrl: string | null, telegramChatUrl: string | null, inviteText: string | null, slogan: string | null, program: string | null, isActive: boolean, requiresRsvpConfirmation: boolean, hasMyTickets: boolean, categories: Array<{ id: string, name: string }>, myRsvp: { id: string, status: RsvpStatus } | null, ticketTypes: Array<{ id: string, name: string, description: string | null, price: string, totalPrice: string, currency: string, maxQuantity: number | null, soldCount: number, available: number | null, feesBreakdown: Array<{ name: string, type: FeeType, amount: string }> }>, homeGroup: { id: string, name: string } | null } | null };

export type AnnouncementEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnnouncementEventsQuery = { announcementEvents: Array<{ id: string, title: string, description: string | null, venue: string | null, startsAt: string, imageUrl: string | null, bannerImageUrl: string | null, ticketTypes: Array<{ id: string, name: string, description: string | null, price: string, totalPrice: string, currency: string, maxQuantity: number | null, soldCount: number, available: number | null }> }> };

export type ScheduleCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ScheduleCategoriesQuery = { categories: Array<{ id: string, name: string, code: string, color: string | null, sortOrder: number }> };

export type CategoryByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type CategoryByCodeQuery = { categoryByCode: { id: string, name: string, code: string, color: string | null } | null };

export type OrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderQuery = { order: { id: string, status: OrderStatus, subtotal: string, feesTotal: string, totalAmount: string, currency: string, expiresAt: string | null, event: { id: string, title: string, startsAt: string, venue: string | null, imageUrl: string | null }, items: Array<{ id: string, quantity: number, unitPrice: string, totalPrice: string, ticketType: { id: string, name: string } }>, fees: Array<{ id: string, name: string, type: FeeType, amount: string }>, pricingOptions: Array<{ id: string, currency: string, subtotal: string, feesTotal: string, total: string, isSelected: boolean, fees: Array<{ id: string, name: string, type: FeeType, calculation: FeeCalculation, amount: string }> }>, selectedPricing: { id: string, currency: string, subtotal: string, feesTotal: string, total: string, fees: Array<{ id: string, name: string, type: FeeType, calculation: FeeCalculation, amount: string }> } | null, manualPayment: { status: string, receiptUrl: string | null } | null, tickets: Array<{ id: string, ticketNumber: string, ticketType: { name: string }, event: { id: string, title: string, startsAt: string, venue: string | null } }>, conversationMessages: Array<{ id: string, messageText: string, createdAt: string, isFromUser: boolean }> } | null };

export type OrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersQuery = { orders: Array<{ id: string, status: OrderStatus, totalAmount: string, currency: string, createdAt: string, event: { id: string, title: string, startsAt: string, imageUrl: string | null }, items: Array<{ quantity: number, ticketType: { name: string } }> }> };

export type TicketsQueryVariables = Exact<{ [key: string]: never; }>;


export type TicketsQuery = { tickets: Array<{ id: string, ticketNumber: string, imageUrl: string | null, issuedAt: string, ticketType: { name: string }, event: { id: string, title: string, startsAt: string, venue: string | null } }> };

export type TicketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TicketQuery = { ticket: { id: string, ticketNumber: string, issuedAt: string, ticketType: { name: string }, event: { id: string, title: string, startsAt: string, venue: string | null } } | null };

export type PaymentRequisitesQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentRequisitesQuery = { paymentRequisites: Array<{ id: string, currency: string, bank: string, account: string, name: string }> };

export const EventBaseFragmentDoc = gql`
    fragment EventBase on Event {
  id
  title
  subtitle
  description
  venue
  startsAt
  imageUrl
  isActive
}
    `;
export const EventTicketTypeFragmentDoc = gql`
    fragment EventTicketType on TicketType {
  id
  name
  description
  price
  totalPrice
  currency
  maxQuantity
  soldCount
  available
}
    `;
export const EventFullFragmentDoc = gql`
    fragment EventFull on Event {
  ...EventBase
  address
  mapsUrl
  endsAt
  videoUrl
  streamYoutubeUrl
  streamVkUrl
  telegramChatUrl
  inviteText
  slogan
  program
  requiresRsvpConfirmation
  hasMyTickets
  myRsvp {
    id
    status
  }
  categories {
    id
    name
    code
    color
  }
  ticketTypes {
    ...EventTicketType
    feesBreakdown {
      name
      type
      amount
    }
  }
  homeGroup {
    id
    name
  }
}
    ${EventBaseFragmentDoc}
${EventTicketTypeFragmentDoc}`;
export const OrderBaseFragmentDoc = gql`
    fragment OrderBase on Order {
  id
  status
  totalAmount
  currency
  createdAt
}
    `;
export const OrderItemFragmentDoc = gql`
    fragment OrderItem on OrderItem {
  id
  quantity
  unitPrice
  totalPrice
  ticketType {
    id
    name
  }
}
    `;
export const OrderFeeFragmentDoc = gql`
    fragment OrderFee on OrderFee {
  id
  name
  type
  amount
}
    `;
export const OrderPricingFeeFragmentDoc = gql`
    fragment OrderPricingFee on OrderPricingFee {
  id
  name
  type
  calculation
  amount
}
    `;
export const OrderPricingFragmentDoc = gql`
    fragment OrderPricing on OrderPricing {
  id
  currency
  subtotal
  feesTotal
  total
  isSelected
  fees {
    ...OrderPricingFee
  }
}
    ${OrderPricingFeeFragmentDoc}`;
export const OrderFullFragmentDoc = gql`
    fragment OrderFull on Order {
  ...OrderBase
  subtotal
  feesTotal
  expiresAt
  event {
    id
    title
    startsAt
    venue
    imageUrl
  }
  items {
    ...OrderItem
  }
  fees {
    ...OrderFee
  }
  pricingOptions {
    ...OrderPricing
  }
  selectedPricing {
    id
    currency
    subtotal
    feesTotal
    total
    fees {
      ...OrderPricingFee
    }
  }
  manualPayment {
    status
    receiptUrl
  }
  tickets {
    id
    ticketNumber
    ticketType {
      name
    }
    event {
      id
      title
      startsAt
      venue
    }
  }
  conversationMessages {
    id
    messageText
    createdAt
    isFromUser
  }
}
    ${OrderBaseFragmentDoc}
${OrderItemFragmentDoc}
${OrderFeeFragmentDoc}
${OrderPricingFragmentDoc}
${OrderPricingFeeFragmentDoc}`;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    id
    status
    totalAmount
    currency
  }
}
    `;

export function useCreateOrderMutation() {
  return Urql.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument);
};
export const ProceedToPaymentDocument = gql`
    mutation ProceedToPayment($orderId: ID!) {
  proceedToPayment(orderId: $orderId) {
    id
    status
  }
}
    `;

export function useProceedToPaymentMutation() {
  return Urql.useMutation<ProceedToPaymentMutation, ProceedToPaymentMutationVariables>(ProceedToPaymentDocument);
};
export const CancelOrderDocument = gql`
    mutation CancelOrder($orderId: ID!) {
  cancelOrder(orderId: $orderId) {
    id
    status
  }
}
    `;

export function useCancelOrderMutation() {
  return Urql.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument);
};
export const SelectPaymentCurrencyDocument = gql`
    mutation SelectPaymentCurrency($orderId: ID!, $currency: String!) {
  selectPaymentCurrency(orderId: $orderId, currency: $currency) {
    id
    currency
    subtotal
    feesTotal
    totalAmount
    pricingOptions {
      id
      currency
      subtotal
      feesTotal
      total
      isSelected
      fees {
        id
        name
        type
        calculation
        amount
      }
    }
    selectedPricing {
      id
      currency
      subtotal
      feesTotal
      total
      fees {
        id
        name
        type
        calculation
        amount
      }
    }
  }
}
    `;

export function useSelectPaymentCurrencyMutation() {
  return Urql.useMutation<SelectPaymentCurrencyMutation, SelectPaymentCurrencyMutationVariables>(SelectPaymentCurrencyDocument);
};
export const ContactManagerDocument = gql`
    mutation ContactManager($orderId: ID!, $message: String!) {
  contactManager(orderId: $orderId, message: $message)
}
    `;

export function useContactManagerMutation() {
  return Urql.useMutation<ContactManagerMutation, ContactManagerMutationVariables>(ContactManagerDocument);
};
export const SetEventRsvpDocument = gql`
    mutation SetEventRsvp($eventId: ID!, $status: RsvpStatus!) {
  setEventRsvp(eventId: $eventId, status: $status) {
    id
    status
  }
}
    `;

export function useSetEventRsvpMutation() {
  return Urql.useMutation<SetEventRsvpMutation, SetEventRsvpMutationVariables>(SetEventRsvpDocument);
};
export const RemoveEventRsvpDocument = gql`
    mutation RemoveEventRsvp($eventId: ID!) {
  removeEventRsvp(eventId: $eventId)
}
    `;

export function useRemoveEventRsvpMutation() {
  return Urql.useMutation<RemoveEventRsvpMutation, RemoveEventRsvpMutationVariables>(RemoveEventRsvpDocument);
};
export const JoinHomeGroupDocument = gql`
    mutation JoinHomeGroup($homeGroupId: ID!) {
  joinHomeGroup(homeGroupId: $homeGroupId) {
    id
  }
}
    `;

export function useJoinHomeGroupMutation() {
  return Urql.useMutation<JoinHomeGroupMutation, JoinHomeGroupMutationVariables>(JoinHomeGroupDocument);
};
export const CreateFeedbackDocument = gql`
    mutation CreateFeedback($text: String!, $authorName: String) {
  createFeedback(text: $text, authorName: $authorName) {
    id
    createdAt
  }
}
    `;

export function useCreateFeedbackMutation() {
  return Urql.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument);
};
export const CreatePastorMessageDocument = gql`
    mutation CreatePastorMessage($text: String!, $authorName: String) {
  createPastorMessage(text: $text, authorName: $authorName) {
    id
    createdAt
  }
}
    `;

export function useCreatePastorMessageMutation() {
  return Urql.useMutation<CreatePastorMessageMutation, CreatePastorMessageMutationVariables>(CreatePastorMessageDocument);
};
export const ChurchInfoDocument = gql`
    query ChurchInfo {
  churchInfo {
    id
    title
    imageUrl
    welcomeText
    scheduleText
    address
    mapUrl
    parkingText
    phone
    email
    companyName
    companyDetails
    usefulChats {
      label
      url
    }
    isActive
  }
}
    `;

export function useChurchInfoQuery(options?: Omit<Urql.UseQueryArgs<ChurchInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<ChurchInfoQuery, ChurchInfoQueryVariables>({ query: ChurchInfoDocument, ...options });
};
export const HomeGroupsPageConfigDocument = gql`
    query HomeGroupsPageConfig {
  homeGroupsPageConfig {
    id
    title
    bodyText
    imageUrl
    isActive
  }
}
    `;

export function useHomeGroupsPageConfigQuery(options?: Omit<Urql.UseQueryArgs<HomeGroupsPageConfigQueryVariables>, 'query'>) {
  return Urql.useQuery<HomeGroupsPageConfigQuery, HomeGroupsPageConfigQueryVariables>({ query: HomeGroupsPageConfigDocument, ...options });
};
export const HomeGroupsDocument = gql`
    query HomeGroups($filter: HomeGroupFilter) {
  homeGroups(filter: $filter) {
    id
    name
    description
    location
    isOpen
    isActive
    memberCount
    imageUrl
    mapsUrl
    leader {
      id
      firstName
      lastName
    }
    schedules {
      id
      dayOfWeek
      startTime
      endTime
      isActive
    }
  }
}
    `;

export function useHomeGroupsQuery(options?: Omit<Urql.UseQueryArgs<HomeGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<HomeGroupsQuery, HomeGroupsQueryVariables>({ query: HomeGroupsDocument, ...options });
};
export const HomeGroupDocument = gql`
    query HomeGroup($id: ID!) {
  homeGroup(id: $id) {
    id
    name
    description
    isOpen
    isMember
    memberCount
    imageUrl
    leader {
      id
      firstName
      lastName
      username
    }
    coLeader {
      id
      firstName
      lastName
      username
    }
    schedules {
      id
      dayOfWeek
      startTime
      endTime
      isActive
    }
  }
}
    `;

export function useHomeGroupQuery(options: Omit<Urql.UseQueryArgs<HomeGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<HomeGroupQuery, HomeGroupQueryVariables>({ query: HomeGroupDocument, ...options });
};
export const EventsDocument = gql`
    query Events($categoryIds: [ID!], $timezone: String, $fromDate: String, $toDate: String, $onlyWithMyRsvp: Boolean, $homeGroupId: ID) {
  events(
    categoryIds: $categoryIds
    timezone: $timezone
    fromDate: $fromDate
    toDate: $toDate
    onlyWithMyRsvp: $onlyWithMyRsvp
    homeGroupId: $homeGroupId
  ) {
    id
    status
    isActive
    title
    subtitle
    description
    venue
    address
    mapsUrl
    startsAt
    imageUrl
    videoUrl
    streamYoutubeUrl
    streamVkUrl
    telegramChatUrl
    inviteText
    slogan
    program
    requiresRsvpConfirmation
    myRsvp {
      id
      status
    }
    hasMyTickets
    categories {
      id
      name
      code
      color
    }
    ticketTypes {
      id
      name
      description
      price
      totalPrice
      currency
      maxQuantity
      soldCount
      available
    }
  }
}
    `;

export function useEventsQuery(options?: Omit<Urql.UseQueryArgs<EventsQueryVariables>, 'query'>) {
  return Urql.useQuery<EventsQuery, EventsQueryVariables>({ query: EventsDocument, ...options });
};
export const EventDocument = gql`
    query Event($id: ID!, $preview: Boolean) {
  event(id: $id, preview: $preview) {
    id
    title
    subtitle
    description
    venue
    address
    mapsUrl
    startsAt
    endsAt
    imageUrl
    videoUrl
    categories {
      id
      name
    }
    streamYoutubeUrl
    streamVkUrl
    telegramChatUrl
    inviteText
    slogan
    program
    isActive
    requiresRsvpConfirmation
    hasMyTickets
    myRsvp {
      id
      status
    }
    ticketTypes {
      id
      name
      description
      price
      totalPrice
      currency
      maxQuantity
      soldCount
      available
      feesBreakdown {
        name
        type
        amount
      }
    }
    homeGroup {
      id
      name
    }
  }
}
    `;

export function useEventQuery(options: Omit<Urql.UseQueryArgs<EventQueryVariables>, 'query'>) {
  return Urql.useQuery<EventQuery, EventQueryVariables>({ query: EventDocument, ...options });
};
export const AnnouncementEventsDocument = gql`
    query AnnouncementEvents {
  announcementEvents {
    id
    title
    description
    venue
    startsAt
    imageUrl
    bannerImageUrl
    ticketTypes {
      id
      name
      description
      price
      totalPrice
      currency
      maxQuantity
      soldCount
      available
    }
  }
}
    `;

export function useAnnouncementEventsQuery(options?: Omit<Urql.UseQueryArgs<AnnouncementEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<AnnouncementEventsQuery, AnnouncementEventsQueryVariables>({ query: AnnouncementEventsDocument, ...options });
};
export const ScheduleCategoriesDocument = gql`
    query ScheduleCategories {
  categories(includeChildren: true) {
    id
    name
    code
    color
    sortOrder
  }
}
    `;

export function useScheduleCategoriesQuery(options?: Omit<Urql.UseQueryArgs<ScheduleCategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<ScheduleCategoriesQuery, ScheduleCategoriesQueryVariables>({ query: ScheduleCategoriesDocument, ...options });
};
export const CategoryByCodeDocument = gql`
    query CategoryByCode($code: String!) {
  categoryByCode(code: $code) {
    id
    name
    code
    color
  }
}
    `;

export function useCategoryByCodeQuery(options: Omit<Urql.UseQueryArgs<CategoryByCodeQueryVariables>, 'query'>) {
  return Urql.useQuery<CategoryByCodeQuery, CategoryByCodeQueryVariables>({ query: CategoryByCodeDocument, ...options });
};
export const OrderDocument = gql`
    query Order($id: ID!) {
  order(id: $id) {
    id
    status
    subtotal
    feesTotal
    totalAmount
    currency
    expiresAt
    event {
      id
      title
      startsAt
      venue
      imageUrl
    }
    items {
      id
      quantity
      unitPrice
      totalPrice
      ticketType {
        id
        name
      }
    }
    fees {
      id
      name
      type
      amount
    }
    pricingOptions {
      id
      currency
      subtotal
      feesTotal
      total
      isSelected
      fees {
        id
        name
        type
        calculation
        amount
      }
    }
    selectedPricing {
      id
      currency
      subtotal
      feesTotal
      total
      fees {
        id
        name
        type
        calculation
        amount
      }
    }
    manualPayment {
      status
      receiptUrl
    }
    tickets {
      id
      ticketNumber
      ticketType {
        name
      }
      event {
        id
        title
        startsAt
        venue
      }
    }
    conversationMessages {
      id
      messageText
      createdAt
      isFromUser
    }
  }
}
    `;

export function useOrderQuery(options: Omit<Urql.UseQueryArgs<OrderQueryVariables>, 'query'>) {
  return Urql.useQuery<OrderQuery, OrderQueryVariables>({ query: OrderDocument, ...options });
};
export const OrdersDocument = gql`
    query Orders {
  orders {
    id
    status
    totalAmount
    currency
    createdAt
    event {
      id
      title
      startsAt
      imageUrl
    }
    items {
      quantity
      ticketType {
        name
      }
    }
  }
}
    `;

export function useOrdersQuery(options?: Omit<Urql.UseQueryArgs<OrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<OrdersQuery, OrdersQueryVariables>({ query: OrdersDocument, ...options });
};
export const TicketsDocument = gql`
    query Tickets {
  tickets {
    id
    ticketNumber
    imageUrl
    issuedAt
    ticketType {
      name
    }
    event {
      id
      title
      startsAt
      venue
    }
  }
}
    `;

export function useTicketsQuery(options?: Omit<Urql.UseQueryArgs<TicketsQueryVariables>, 'query'>) {
  return Urql.useQuery<TicketsQuery, TicketsQueryVariables>({ query: TicketsDocument, ...options });
};
export const TicketDocument = gql`
    query Ticket($id: ID!) {
  ticket(id: $id) {
    id
    ticketNumber
    issuedAt
    ticketType {
      name
    }
    event {
      id
      title
      startsAt
      venue
    }
  }
}
    `;

export function useTicketQuery(options: Omit<Urql.UseQueryArgs<TicketQueryVariables>, 'query'>) {
  return Urql.useQuery<TicketQuery, TicketQueryVariables>({ query: TicketDocument, ...options });
};
export const PaymentRequisitesDocument = gql`
    query PaymentRequisites {
  paymentRequisites {
    id
    currency
    bank
    account
    name
  }
}
    `;

export function usePaymentRequisitesQuery(options?: Omit<Urql.UseQueryArgs<PaymentRequisitesQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentRequisitesQuery, PaymentRequisitesQueryVariables>({ query: PaymentRequisitesDocument, ...options });
};